import { formatISO, isValid, parseISO } from "date-fns";

export const isDateValue = (value: unknown): boolean => {
  if (!value) return false;

  if (value instanceof Date) {
    return isValid(value);
  }

  if (typeof value === "string") {
    try {
      const parsedDate = parseISO(value);
      return isValid(parsedDate);
    } catch {
      return false;
    }
  }

  return false;
};

export const correctDateTimezone = (dateValue: string | Date): string => {
  const date = typeof dateValue === "string" ? parseISO(dateValue) : dateValue;

  return formatISO(date);
};

export const transformSupabaseDates = (data: unknown): unknown => {
  if (data === null || data === undefined) {
    return data;
  }

  if (typeof data !== "object") {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map((item) => transformSupabaseDates(item));
  }

  const transformed: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(data)) {
    if (isDateValue(value)) {
      transformed[key] = correctDateTimezone(value as string | Date);
    } else if (typeof value === "object" && value !== null) {
      transformed[key] = transformSupabaseDates(value);
    } else {
      transformed[key] = value;
    }
  }

  return transformed;
};

export const transformDateField = (dateValue: unknown): unknown => {
  if (isDateValue(dateValue)) {
    return correctDateTimezone(dateValue as string | Date);
  }
  return dateValue;
};
